import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "d-flex justify-space-between" }
const _hoisted_2 = { class: "text-decoration-none" }
const _hoisted_3 = { class: "mainInputs" }
const _hoisted_4 = { class: "mainInputs" }
const _hoisted_5 = { class: "d-flex justify-space-between align-center mb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_custom_img_component = _resolveComponent("custom-img-component")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "8" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _cache[13] || (_cache[13] = _createElementVNode("h1", { class: "titleSt" }, "Componente Múltiplas Fotos Simples", -1)),
              _createElementVNode("a", _hoisted_2, [
                _createVNode(_component_v_btn, {
                  class: "text-white",
                  color: "grey",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close-modal')))
                }, {
                  default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                    _createTextVNode("Cancelar", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  class: "text-white",
                  color: "#ff5000",
                  onClick: _ctx.store,
                  disabled: _ctx.btn_disabled
                }, {
                  default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                    _createTextVNode("Salvar", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick", "disabled"])
              ])
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_v_text_field, {
                modelValue: _ctx.fragmentId,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.fragmentId) = $event)),
                label: "ID do componente",
                "hide-details": "auto",
                onKeyup: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onInputChange()))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_v_text_field, {
                modelValue: _ctx.title,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.title) = $event)),
                label: "Título",
                rules: _ctx.rules,
                "hide-details": "auto",
                onKeyup: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onInputChange()))
              }, null, 8, ["modelValue", "rules"])
            ]),
            _createElementVNode("div", null, [
              _cache[19] || (_cache[19] = _createElementVNode("hr", null, null, -1)),
              _cache[20] || (_cache[20] = _createElementVNode("h2", null, "Fotos", -1)),
              _createElementVNode("div", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.photoItems, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.id,
                    class: "mainInputs"
                  }, [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("h3", null, "Foto " + _toDisplayString(item.id), 1),
                      (item.id != 1)
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 0,
                            color: "red",
                            size: "small",
                            onClick: ($event: any) => (_ctx.removePhotoItem(item.id))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                                  _createTextVNode("mdi-delete", -1)
                                ]))]),
                                _: 1
                              }),
                              _cache[15] || (_cache[15] = _createTextVNode(" Remover ", -1))
                            ]),
                            _: 1
                          }, 8, ["onClick"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode(_component_v_text_field, {
                      modelValue: item.fragmentPhotoItemId,
                      "onUpdate:modelValue": ($event: any) => ((item.fragmentPhotoItemId) = $event),
                      label: "ID do item da foto",
                      "hide-details": "auto",
                      onKeyup: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onInputChange()))
                    }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                    _createVNode(_component_v_text_field, {
                      modelValue: item.title,
                      "onUpdate:modelValue": ($event: any) => ((item.title) = $event),
                      label: "Título",
                      rules: _ctx.rules,
                      "hide-details": "auto",
                      onKeyup: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onInputChange()))
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "rules"]),
                    _createVNode(_component_v_text_field, {
                      modelValue: item.description,
                      "onUpdate:modelValue": ($event: any) => ((item.description) = $event),
                      label: "Descrição",
                      rules: _ctx.rules,
                      "hide-details": "auto",
                      onKeyup: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onInputChange()))
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "rules"]),
                    _createVNode(_component_v_text_field, {
                      modelValue: item.imageUrl,
                      "onUpdate:modelValue": ($event: any) => ((item.imageUrl) = $event),
                      label: "URL da imagem",
                      rules: _ctx.rules,
                      "hide-details": "auto",
                      onKeyup: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onInputChange()))
                    }, {
                      "prepend-inner": _withCtx(() => [
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                            _createTextVNode("mdi-link", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue", "onUpdate:modelValue", "rules"]),
                    _createVNode(_component_v_switch, {
                      modelValue: item.requirePhoto,
                      "onUpdate:modelValue": ($event: any) => ((item.requirePhoto) = $event),
                      color: _ctx.movida_color,
                      onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.verifyBtnDisabled())),
                      label: 'Foto obrigatória? ' + (item.requirePhoto ? 'Sim' : 'Não')
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "color", "label"])
                  ]))
                }), 128)),
                _createVNode(_component_v_btn, {
                  onClick: _ctx.addPhotoItem,
                  color: "primary",
                  class: "mt-2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                        _createTextVNode("mdi-plus", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[18] || (_cache[18] = _createTextVNode(" Adicionar foto ", -1))
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { cols: "4" }, {
          default: _withCtx(() => [
            _createVNode(_component_custom_img_component, { imageSrc: _ctx.imageSrc }, null, 8, ["imageSrc"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_snackbar, {
      modelValue: _ctx.snackbar,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.snackbar) = $event)),
      timeout: _ctx.timeout
    }, {
      actions: _withCtx(() => [
        _createVNode(_component_v_btn, {
          variant: "text",
          onClick: _ctx.closeSnack
        }, {
          default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
            _createTextVNode(" Fechar ", -1)
          ]))]),
          _: 1
        }, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_v_icon, { class: "ml-1" }, {
          default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
            _createTextVNode(" mdi-information-outline ", -1)
          ]))]),
          _: 1
        }),
        _createTextVNode(" " + _toDisplayString(_ctx.text) + " ", 1)
      ]),
      _: 1
    }, 8, ["modelValue", "timeout"])
  ], 64))
}